import React from "react";
import { Navigate, Outlet } from "react-router-dom";

function PrivateRoute() {
  const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));
  return accessToken ? <Outlet /> : <Navigate to={"/login"} />;
}

export default PrivateRoute;
